export default __webpack_public_path__ + "static/O0008-c0901066eb09ea0f658d24ed12983a44.png";